import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput, ColorInput } from '../../../Form';

@inject('ticketStatusStore')
@observer
class StatusEdit extends Component {
  // static propTypes = {
    // route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
      // id: PropTypes.string.isRequired,
    // }).isRequired,
    // unitStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/status';
  title = 'Edit Ticket Status';
  disposer = null;
  @observable item = {
    caption : '',
    description: '',
    color: ''
  };

  constructor(props) {
    super(props);

    const { params: { id }, ticketStatusStore } = props;

    ticketStatusStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id }, ticketStatusStore } = this.props;
    const foundStatus = ticketStatusStore.findById(id);
    if (foundStatus) {
      this.item = foundStatus.asJson;
    }
  }

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { ticketStatusStore } = this.props;
    ticketStatusStore.updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  }

  render() {
    const { ticketStatusStore, params: { id } } = this.props;

    if (ticketStatusStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={ticketStatusStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default StatusEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Status/StatusEdit.js